import React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    SelectInput,
    ReferenceInput,
    AutocompleteInput,
    FormDataConsumer,
    required,
} from 'react-admin';
import { CUSTOM_FIELD_TYPES_CHOICES } from '../../../../config/api';
import { OptionsChipInput } from '../common';

const CustomFieldEdit = () => (
    <Edit redirect="show">
        <SimpleForm>
            <ReferenceInput
                source="client_id"
                reference="clients"
                label="Cliente"
                sort={{ field: 'name', order: 'ASC' }}
                perPage={1000}
            >
                <AutocompleteInput
                    optionText="name"
                    filterToQuery={searchText => ({ name: searchText })}
                    validate={[required()]}
                />
            </ReferenceInput>
            <TextInput source="name" validate={[required()]} />
            <TextInput source="slug" validate={[required()]} />
            <SelectInput source="type" choices={CUSTOM_FIELD_TYPES_CHOICES} validate={[required()]} />
            <FormDataConsumer>
                {({ formData }) => formData.type === 'select' && <OptionsChipInput />}
            </FormDataConsumer>
        </SimpleForm>
    </Edit>
);

export default CustomFieldEdit;
